import { SDInputOverrides } from '@/shared/components/SDComponents/SDInput/styled-components'

export const SDDatePickerOverrides = () => ({
  Input: {
    props: {
      overrides: SDInputOverrides(),
    },
  },
})
